// Lightbox timeshift toggle

class Lightbox {
    constructor(elem) {
        this.lightbox = elem;
    }

    init() {
        const delayInMilliseconds = this.lightbox.getAttribute('data-delay') * 1000;
        // Opens Lightbox after defined Time
        Lightbox.toggleOpener(this.lightbox, delayInMilliseconds);

        this.lightbox.addEventListener('click', (event) => {
            if (event.target.hasAttribute('data-close-trigger')) {
                event.preventDefault();
                Lightbox.toggleOpener(this.lightbox);
            }
        });
    }

    static toggleOpener(element, delayInMilliseconds) {
        setTimeout(() => {
            element.classList.toggle('open');
        }, delayInMilliseconds);
    }
}

export default Lightbox;
